import { useEffect, useMemo, useState } from "react"
import { convertTo12HourFormat, dateConvert, timeStringToDate } from "../../../utils/Helper";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";

export const usePunchReport = ({ filterValues, hoveredRange, callPunchApi, setCallPunchApi }) => {

    const [loader, setLoader] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [colDef] = useState([
        {
            field: "manager_name",
            headerName: "Manager Name",
            rowGroup: true,
            hide: true,
            width: 150,
        },
        {
            field: "user_display_name",
            headerName: "Employee Name",
            rowGroup: true,
            hide: true,
            width: 150,
            pinned: "left"
        },
        {
            field: "shift_date",
            headerName: "Shift Date",
            width: 100,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value && dateConvert(params?.value, "day-month-year")}</div>
                )
            }
        },
        {
            field: "day_name",
            headerName: "Day",
            width: 50,
            cellStyle: { textAlign: "center" }
        },
        {
            field: "shift_startdate",
            headerName: "Shift In",
            width: 80,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value && convertTo12HourFormat(params?.value)}</div>
                )
            }
        },
        {
            field: "shift_enddate",
            headerName: "Shift Out",
            width: 80,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value && convertTo12HourFormat(params?.value)}</div>
                )
            }
        },
        {
            field: "actual_starttime",
            headerName: "Punch In",
            width: 80,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                const shiftStart = params?.data?.shift_startdate
                const classname = dateConvert((params?.value && timeStringToDate(params?.value)), "iso-string") <= dateConvert(shiftStart && timeStringToDate(shiftStart), "iso-string") ? "text-success" : "text-danger"
                return (
                    <div className={classname}>{params?.value && convertTo12HourFormat(params?.value)}</div>
                )
            }
        },
        {
            field: "actual_endtime",
            headerName: "Punch Out",
            width: 80,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                const shiftEnd = params?.data?.shift_enddate
                const classname = dateConvert((params?.value && timeStringToDate(params?.value)), "iso-string") >= dateConvert(shiftEnd && timeStringToDate(shiftEnd), "iso-string") ? "text-success" : "text-danger"
                return (
                    <div className={classname}>{params?.value && convertTo12HourFormat(params?.value)}</div>
                )
            }
        },
        {
            field: "insights_starttime",
            headerName: "Tap In",
            width: 80,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                const shiftStart = params?.data?.shift_startdate
                const classname = dateConvert((params?.value && timeStringToDate(params?.value)), "iso-string") <= dateConvert(shiftStart && timeStringToDate(shiftStart), "iso-string") ? "text-success" : "text-danger"
                return (
                    <div className={classname}>{params?.value && convertTo12HourFormat(params?.value)}</div>
                )
            }
        },
        {
            field: "insights_endtime",
            headerName: "Tap Out",
            width: 80,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                const shiftEnd = params?.data?.shift_enddate
                const classname = dateConvert((params?.value && timeStringToDate(params?.value)), "iso-string") >= dateConvert(shiftEnd && timeStringToDate(shiftEnd), "iso-string") ? "text-success" : "text-danger"
                return (
                    <div className={classname}>{params?.value && convertTo12HourFormat(params?.value)}</div>
                )
            }
        },
        {
            field: "insights_lunch_starttime",
            headerName: "Lunch In",
            width: 80,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value && convertTo12HourFormat(params?.value)}</div>
                )
            }
        },
        {
            field: "insights_lunch_endtime",
            headerName: "Lunch Out",
            width: 80,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value && convertTo12HourFormat(params?.value)}</div>
                )
            }
        },
        {
            field: "working_hours",
            headerName: "Working Hours",
            width: 80,
            cellStyle: { textAlign: "center" },
            headerClass: "header-wrap"
        },
        {
            field: "extra_hours_decimal",
            headerName: "Extra Hours",
            width: 80,
            cellStyle: { textAlign: "center" },
        },
        {
            field: "deficit_hours",
            headerName: "Deficit",
            width: 80,
            cellStyle: { textAlign: "center" },
        },
        {
            field: "in_remark",
            headerName: "In Remark",
            width: 150,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div title={params?.value}>{params?.value}</div>
                )
            }
        },
        {
            field: "out_remark",
            headerName: "Out Remark",
            width: 150,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div title={params?.value}>{params?.value}</div>
                )
            }
        },
    ]);

    useEffect(() => {
        callPunchApi && getPunchReport();
    }, [callPunchApi])
    useEffect(() => {
        filterValues?.apiCall && getPunchReport();
    }, [filterValues.type])

    const getPunchReport = async () => {
        try {
            setLoader(true);
            setRowData([]);
            const payload = {
                project_lead_user_code: _.pluck(filterValues?.project_leads, "user_code")?.toString() || "",
                from_date: dateConvert(hoveredRange?.[0]?.toDate(), 'iso-string') || "",
                to_date: dateConvert(hoveredRange?.[1]?.toDate(), 'iso-string') || "",
                users: _.pluck(filterValues?.users, "user_code")?.toString() || "",
                log_in_out_type: filterValues?.type || "",
                requested_shift_minutes: filterValues?.type !== "I" && filterValues?.type !== "O" ? 0 : filterValues?.time ? parseInt(filterValues?.time) : 0
            }
            const res = await services.getInvokeRemote("POST", Urls("GETDAILYPUNCHINDETAILS"), payload);
            if (res) {
                const data = res?.body?.data?.manager_attandance_details;
                const sortedData = data?.sort((a, b) => {
                    if (a?.manager_name < b?.manager_name) return -1;
                    if (a?.manager_name > b?.manager_name) return 1;
                    return a?.user_display_name?.localeCompare(b?.user_display_name);
                });
                setRowData(_.uniq(sortedData, item => `${item?.shift_date}-${item?.user_display_name}`));
            }
            setCallPunchApi(false);
            setLoader(false);
        } catch (error) {
            console.error("Error: ", error);
            setCallPunchApi(false);
            setLoader(false);
        }
    }

    return useMemo(() => ({
        rowData, colDef, loader
    }), [rowData, colDef, loader])
}